export const de = {

  "__currency_code__":"EUR",
  __currency__: "EUR",
  __currency_symbol__: "€",
  __locale__: "de-DE",

  "2d": "2D",
  "3d": "3D",

  "Ahşap Seçeneği": "Holzoption",
  "Ayak Tipi": "Fußtyp",
  "Ayak Rengi": "Fußfarbe",
  "Ayak Seçeneği": "Fußvariante ",

  "Kumaş Seçeneği": "Stoffoptinen",
  "Kumaş Tipi": "Stofftyp",
  "Kumaş Rengi": "Stofffarbe",

  "Sırt Minderi Tipi": "Rückenkissen",
  "Sırt Tipi": "Rückenkissen",
  "Kol Tipi": "Armlehnenoption",

  "Kalın Kol": "Fett Arm",
  "İnce Kol": "Schmal Arm",

  "Rahat Dolgu": "Gefülltes Rückenkissen",
  "Kalıcı Form": "Block-Rückenkissen",

  "Klem Üçlü Modül": "Klem 3-Sitzer Module",
  "Klem İkili Modül": "Klem 2-Sitzer Module",
  "Klem Tekli Modül": "Klem Einsitzer Module",
  "Klem Tekli Large Modülü": "Klem Einstzer Grob Module",
  "Klem Loveseat Modülü": "Klem Loveseat Module",

  "Klem Köşe Modülü": "Klem Eck Module",
  "Klem Dinlenme Modülü": "Klem Recamiere Module",
  "Klem Puf": "Klem Hocker",
  "Klem Puf Small": "Klem Hocker Klein",
  "Klem Bench": "Klem Bank",

  "Muly Baş Desteği": "Muly Sofakopfstütze",
  "Modsy Berjer": "Modsy Akzentstuhl Holzbein",
  "Levy Meşe Berjer": "Levy Eiche Akzentstuhl",

  "Ahşap Ayak": "Koniche Holzbeine",
  "Silindir Ahşap Ayak": "Zylindrische Holzbeine",

  Açık: "Hell",
  Koyu: "Dunkel",
  Siyah: "Schwarz",

  "Doğal Doku": "Naturgewebe",
  Kadife: "Samt",
  Keten: "Gewebe",
  "Fitilli Kadife": "Cord Velours",
  Bukle: "Boucle",
  "Performans Kadife": "Gewebter Samt",
  "Performans Keten": "Performance-Stoff",

  Çakıl: "Kiesgrau",
  "Havacı Mavi": "Aviatorblau",
  "Beton Gri": "Betongrau",
  "Nil Yeşili": "Nilgrün",

  Füme: "Rauchgrau",
  Fildişi: "Elfenbein",
  "Mermer Gri": "Marmorgrau",
  "Galaksi Mavi": "Himmelsblau",
  Kaktüs: "Cactus",

  Haki: "Khaki",
  "Paslı Kırmızı": "Rostrot",
  "Gece Mavisi": "Mitternachtsblau",
  "Çağla Yeşili": "Mintgrün",
  Vanilya: "Vanille",
  Kiremit: "Ziegelrot",
  Gri: "Grau",
  "Zümrüt Yeşili": "Smaragdgrün",
  Hardal: "Senfgelb",
  Ekru: "Ecru",
  "Kül Gri": "Aschgrau",

  Kemik: "Knochen",
  "Polen Sarı": "Polengelb",
  "Sisli Yeşil": "Nebelgrün",
  "Sutlu Kahve": "Milchkaffee",
  Ziegelrot: "Ziegelrot",
  Grau: "Grau",
  Mavi: "Blau",

  "Deniz Köpüğü": "Meerschaum",
  Uzay: "Platz",

  Kehribar: "Schatz",
  Kum: "Eisblau",
  Bej: "Creme",
  "Yosun (Infinity 792": "Kieferngrün",
  Terra: "Kupfer",

  "Ada Çayı": "Salbeigrün",
  "Duman Gri": "Dunstiges Grau",
  Tuğla: "Terrakotta",

  "Klem İkili Gövde 154 Cm": "Klem 2-Sitzer Module 154 Cm",
  "Klem İkili Gövde 154 Cm Blok Sırt":
    "Klem 2-Sitzer Module 154 Cm Block Rücks",

  "Klem Üçlü Gövde 180 Cm": "Klem 3-Sitzer Module 180 Cm",
  "Klem Üçlü Gövde 180 Cm Blok Sırt": "Klem 3-Sitzer Module 180 Cm Block Rücks",
  "Klem Bench Gövde": "Klem Bank Module",
  "Klem Dinlenme Gövde": "Klem Recamiere Module",
  "Klem Dinlenme Gövde Blok Sırt": "Klem Recamiere Module Block Rücks",
  "Klem Kol Seti": "Klem Arm Set",
  "Modsy Kol Seti": "Modsy Arm Set",
  "Klem Köşe Gövde": "Klem Eck Module",
  "Klem Köşe Gövde Blok Sırt": "Klem Eck Module Block Rücks",
  "Klem Puf Gövde": "Klem Hocker Module",
  "Klem Puf Small Gövde": "Klem Hocker Klein Module",
  "Klem Tekli Gövde 100 Cm": "Klem Sessel Module 100 Cm",
  "Klem Tekli Gövde 100 Cm Blok Sırt": "Klem Sessel Module 100 Cm Block Rücks",
  "Klem Tekli Gövde 64 Cm Blok Sırt": "Klem Sessel Module 64 Cm Block Rücks",
  "Klem Tekli Gövde 77 Cm": "Klem Sessel Module 77 Cm",
  "Konik Ahşap Ayak 4lü Set": "Set mit 4 Holzbeinen",
  "Konik Ahşap Orta Ayak 2li Set": "Set mit 2 Stütz-holzbeinen",
  "Konik Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Holzbeinen",
  "Konik Ayak": "Conic",

  "Silindir Ahşap Ayak 4lü Set": "Set mit 4 Zylindrischen Holzbeinen",
  "Silindir Ahşap Orta Ayak 2li Set": "Set mit 2 Zylindrischen Stützbeinen",
  "Silindir Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Zylindrischen Holzbeinen",
  "18 Cm Silindir Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Holzbeinen",
  "18 Cm Ahşap Ayak 4lü Set": "Set mit 4 Holzbeinen",
  "18 Cm Ahşap Orta Ayak 2li Set": "Set mit 2 Stütz-holzbeinen",
  "18 Cm Dinlenme Ahşap Ayak 6lı Set": "Set mit 6 Zylindrischen Holzbeinen",
  "18 Cm Silindir Ahşap Ayak 4lü Set": "Set mit 4 Zylindrischen Holzbeinen",
  "18 Cm Silindir Ahşap Orta Ayak 2li Set":
    "Set mit 2 Zylindrischen Stützbeinen",

  "Dolgu Sırt Minderi": "Gefülltes Rückenkissen",
  "Blok Sırt Minderi": "Block-Rückenkissen",

  confirm: "Bestätigen",
  confirmshape: "Form aktualisieren",
  notFound: "Nicht gefunden",
  next: "Weiter",
  back: "Zurück",
  export: "Exportieren",
  gapWidth: "Spaltenbreite",
  wallWidth: "Wandbreite",
  balconyWidth: "Balkonbreite",
  clearAllTip: "Alles löschen",
  drawBalconyTip: "Balkon zeichnen",
  drawWallTip: "Wand zeichnen",
  drawGapTip: "Lücke zeichnen",
  search: "Suchen",
  //WelcomeMenu.tsx
  welcomeMenuWelcome: "Hallo! Willkommen beim Planer!",
  drawRoomShape: "Eigenen Raum zeichnen",
  chooseRoomShapeFromTemplates: "Aus Vorlagen wählen",
  chooseRoomShape: "Raumform wählen",
  //MainPane.tsx
  roomFeatures: "Größe",
  drawWall: "Abmessungen",
  showReport: "Angebot",
  addToRoom: "Produkte",
  configure: "Konfigurieren",
  //RoomShaping.tsx
  changeRoomShape: "Raumform ändern",
  newRoom: "Löschen",
  roomShapeOnlyFloor: "Boden",
  roomShapeFloorWithSingleWall: "Einzelne Wand",
  roomShapeCorner: "Ecke",
  roomDoubleBalcony: "Eckform",
  roomShapeRectangle: "Rechteck",
  roomShapeSquare: "Quadrat",
  roomShapeLShape: "L-Form",
  roomShapeZShape: "Z-Form",
  roomShapeUShape: "U-Form",
  roomShapeTShape: "T-Form",
  roomShape5Sides: "5-seitig",
  roomShapeBevelShape: "Abgeschrägte Form",
  //RoomModifying.tsx
  wallResize: "Wände skalieren",
  glassPriceMultiplier: "Glaspreis pro Meter",
  basePriceMultiplier: "Basispreis pro Einheit",
  buyerName: "Käufername",
  dimensions: "Abmessungen",
  resetArea: "Bereich zurücksetzen",
  undo: "Rückgängig",
  topView: "Draufsicht",
  calculating: "Wird berechnet...",
  loading: "Wird geladen...",
  productList: "Produktliste",
  proforma: {
    modelSummary: "Normod Zusammenfassung",
    pdfGenerating: "PDF wird erstellt...",
    pdfLibraryError: "PDF-Bibliothek konnte nicht geladen werden",
    pdfError:
      "PDF konnte nicht erstellt werden. Bitte versuchen Sie es erneut.",
    pdfError2:
      "Beim Erstellen des PDFs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    offerNo: "Angebotsnummer",
    quantity: "Menge",
    product: "Produkt",
    price: "Preis",
    subtotal: "Zwischensumme",
    dimensions: "Abmessungen",
    materialType: "Materialtyp",
    materialColor: "Materialfarbe",
    orderDate: "Bestelldatum",
    discount: "Rabatt",
    taxIncluded: "Steuer (inkl.) MwSt-10%",
    total: "GESAMTSUMME",
    footer1: "Unsere Preise enthalten die Mehrwertsteuer.",
    footer2: "Die Preise gelten für den Tag der Erstellung des Formulars.",
    footer3:
      "Dieses Formular dient nur zu Angebotszwecken und kann nicht für Bestellungen verwendet werden.",
    footer4:
      "Dieses Design wurde speziell für die Person am {{date}} erstellt.",
    footer5:
      "Unsere Produkte sind auf Komfort ausgelegt. Da reichhaltige Fasern und hochelastische Premium-Schwämme verwendet werden, können Nähte unregelmäßig sein.",
    footer6: "Die Farben auf dem Bildschirm können abweichen.",
    footer7: "Die Gültigkeitsdauer des Angebots beträgt 3 Tage.",
    preview3d: "3D Vorschau",
    setProjectName: "Projektnamen festlegen",
    pdfWillBeSavedAs: "Die PDF-Datei wird mit diesem Namen gespeichert",
    projectName: "Projektname",
    projectNamePlaceholder: "z.B. Küchendesign",
    cancel: "Abbrechen",
    createPdf: "PDF erstellen",
    priceAsc: "Preis ↑",
    priceDesc: "Preis ↓",
    sort: "Sortieren",
    productDetails: "Produktdetails",
    cm: "cm",
    addToCart: "In den Warenkorb",
    share: "Teilen",
  },
  side: {
    backCushion: "Rückenkissen",
    armOption: "Armlehnenoption",
    fabricDetails: "Stoffdetails",
    apply: "Anwenden",
    materialGroupDescription:
      "Wähle aus den gefundenen Stoffarten und wähle deine gewünschte Farbe aus der Untergruppe, um dein Produkt zu individualisieren.",
  },
};
